import { configureStore } from '@reduxjs/toolkit'
import reducer from 'redux-thunk/redux/index'

const store = configureStore({
  reducer
})

export default store
